import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Flex, GradientButton } from '../../../components';

import Logo from '../../../assets/Logo.png';

const Container = styled(Flex)`
  margin: 40px 0;
  position: relative;
`;

const Navbar = () => {
  const history = useHistory();

  const logout = () => {
    axios
      .get('/api/auth/logout')
      .then(res => {
        history.push("/home")
      })
      .catch(err => {
        console.error(err);
      });

  };

  return (
    <Container dir="row" w="100%" h="60px" align="center">
      <Link to="/home">
        <img style={{ zIndex: 1000, cursor: 'pointer' }} src={Logo} alt="" />
      </Link>
      <Flex fg="1" />
      <GradientButton onClick={logout} text="Logout" />
    </Container>
  );
};

export default Navbar;
